import React from "react";

import { SlimButton } from "components/Button/index";

import { supportPhone } from "constants/agrinous";

import { openPhoneSupport } from "lib/navigation";

export function PhoneSupportButton() {
  return <SlimButton onClick={openPhoneSupport}>{supportPhone}</SlimButton>;
}
